import {IGridModel} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';

export class GridModelPrinter
{
    public static print(gridModel:IGridModel):void
    {
        const columnHeaders = gridModel.getColumnHeaders();

        const bodyWithRowHeaders = gridModel.getBodyWithRowHeaders();
        const numRows = bodyWithRowHeaders.getNumRows();
        const numColumns = bodyWithRowHeaders.getNumColumns();

        let tableFn = console.table;

        if( !tableFn || !(typeof tableFn === 'function') )
            return;

        const tableData = [];

        const typesRow = {};
        tableData.push(typesRow);
        for( let columnIndex = 0; columnIndex < numColumns; columnIndex++ )
        {
            const columnKey = gridModel.getColumnKeyAtIndex(columnIndex, true);
            const cell = columnHeaders.getCellAt(0, columnIndex);

            typesRow[columnKey] = cell.toString();
        }

        for( let rowIndex = 0; rowIndex < numRows; rowIndex++ )
        {
            const row = {};
            tableData.push(row);

            for( let columnIndex = 0; columnIndex < numColumns; columnIndex++ )
            {
                const columnKey = gridModel.getColumnKeyAtIndex(columnIndex, true);
                let cell;
                try
                {
                    cell = bodyWithRowHeaders.getCellAt(rowIndex, columnIndex);
                }
                catch (e)
                {
                    let x = 5;
                }

                if( cell )
                    row[columnKey] = cell.toString();
                else
                    row[columnKey] = 'NO VALUE!!!';
            }
        }

        tableFn(tableData);
    }
}
